import { Button } from '@mui/material';
import { VyIcon } from '@weft/icons';
type DownloadReportButtonProps = {
  onClick: () => void;
};

export const DownloadReportButton: React.FC<DownloadReportButtonProps> = ({ onClick }) => {
  return (
    <Button
      variant='outlined'
      size='small'
      color='primary'
      onClick={onClick}
      endIcon={
        <VyIcon
          icon='Download'
        />}
    >
      Download
    </Button>
  );
};